module.exports = __webpack_public_path__ + "img/zoom.7a88adee.png";